<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="600px"
    scrollable
    v-if="display"
  >
    <v-form ref="form">
      <v-card min-height="200px">
        <v-card-title>
          <div class="headline">
            Demande de modification d'un dossier de<br />demande d'agrément
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col> établissement: {{ dossier.officine.denomination }}</v-col>
            <v-col>
              date de la demande: {{ getDate(dossier.dateDepot) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col> demandeur: {{ dossier.demandeur }}</v-col>
            <v-col>
              type de la demande:
              {{
                dossier.premiereDemande ? "Première demande" : "Renouvellement"
              }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="motif"
                label="motif"
                :rules="motifRules"
                class="required"
                outlined
                auto-grow
                clearable
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            class="white--text"
            @click="displayed = false"
            color="primary"
          >
            Annuler
          </v-btn>
          <v-btn
            small
            class="white--text"
            @click="demanderModification()"
            color="primary"
          >
            Demander une modification
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import common from "@/common";

export default {
  name: "ModalVoirAvisRPO",
  props: ["dossier", "display"],
  data() {
    return {
      motif: null,
      motifRules: [
        v =>
          !!v ||
          "La raison de la demande de modification du dossier est obligatoire"
      ]
    };
  },
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    }
  },
  methods: {
    getDate(timestamp) {
      return common.formatDate(timestamp);
    },
    demanderModification() {
      if (this.$refs.form.validate()) {
        this.$emit("ModalDemandeModificationAction", {
          dossier: this.dossier,
          motif: this.motif
        });
        this.$refs.form.reset();
        this.displayed = false;
      }
    }
  }
};
</script>
<style>
.required label::after {
  content: "*";
  color: red;
}
</style>
